import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject, Subscriber } from 'rxjs';
import { ToastController } from '@ionic/angular';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { AngularFirestore } from '@angular/fire/firestore';

// Push Notifications
import { OneSignal } from '@ionic-native/onesignal/ngx';
import { map } from 'rxjs/operators';
import * as firebase from 'firebase/app';
import 'firebase/auth';
// Encriptacion
import {Md5} from 'ts-md5/dist/md5';
import { formatNumber } from '@angular/common';

// Get product from Localstorage
let products = JSON.parse(localStorage.getItem("cartItem")) || [];
let favoritos = JSON.parse(localStorage.getItem("favItem")) || [];
let LastItem  = JSON.parse(window.localStorage.getItem('LastItem'));
let LastCat  = JSON.parse(window.localStorage.getItem('LastCat')) || [];
let LastSearch  = JSON.parse(window.localStorage.getItem('LastSearch')) || [];
@Injectable({
  providedIn: 'root'
})
export class ApiRestServicesService {
  /** Audios */
    audio_inCart = new Audio("assets/audio/add_cart.wav");
    audio_RemoveCart = new Audio("assets/audio/remove_cart.mp3");
  /** Audios */
  
  /** Path del ApiRest */
  UrlPath = "https://restapi.cosasymasac.com/app_mobile/app.php/";
  /** Path del ApiRest */

  /** Observables del User */
    private User  = new BehaviorSubject<any>('');
    User$ = this.User.asObservable();
  /** Observables del User */


  /** Observables de Cart */
    private Total_Cart = new BehaviorSubject<any>('');
    Total_Cart$ = this.Total_Cart.asObservable();
  /** Observables de Cart */
  
  /** Observables de Favoritos */
    private Total_Favs = new BehaviorSubject<any>('');
    Total_Favs$ = this.Total_Favs.asObservable();
  /** Observables de Favoritos */

  /** Observables de LastItemViewer */
    private LastItem_view = new BehaviorSubject<any>('');
    LastItem_view$ = this.LastItem_view.asObservable();
  /** Observables de LastItemViewer */

  /** Observables para LastCat */
    public LastCatView = new BehaviorSubject<any>('');
  
  /** Observable para LastSearch */
  public LastSearchView = new BehaviorSubject<any>('');
  get windowRef() {
    return window
  }

  constructor(
    private http: HttpClient,
    private firestore: AngularFirestore,
    private md5: Md5,
    public toastController: ToastController,
    private oneSignal: OneSignal
  ) {
    
   }

  /************** Obtenemos numero de contacto *********/

  public GetContactAdmin() {
    const data = {
      bandera: 'GetAdminPhone'
    }
    return this.http.post(this.UrlPath,data,{
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    }).toPromise();
  }

  /*********** OBtenemos los puntos y sus valores actuales *************/
  public GetValuePoint() {
    const data = {
      bandera: 'GetValuePoint'
    }
    return this.http.post(this.UrlPath,data,{
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    }).toPromise();
  }

  /************** Carrito de compras ***************/
  // Get Products
  public getItems(): Observable<any[]> {
    const itemsStream = new Observable(observer => {
      observer.next(products);
      observer.complete();
    });
    return <Observable<any[]>>itemsStream;
  }

  // Add to cart
  public addToCart(product: any, quantity: number) {
      let message, status;
      var item: any | boolean = false;
      // If Products exist
      let hasItem = products.find((items, index) => {
        if(items.product.id == product.id) {
          let qty = products[index].quantity + quantity;
          products[index]['quantity'] = qty;
          message = 'Tienes '+ qty + ' Productos agregados';
          status = 'success';
          this.presentToast(message, "top", 'primary');
          return true;
        }
      });

      // If Products does not exist (Add New Products)
      if(!hasItem) {
        item = { product: product, quantity: quantity };
        products.push(item);
        message = 'El producto ha sido añadido.';
        this.presentToast(message, "bottom", 'primary');
      }
      this.audio_inCart.play();
      localStorage.setItem("cartItem", JSON.stringify(products));
      this.getTotalAmount();
      return item;
  }

  // Removed in cart
  public removeFromCart(item: any) {
    if (item === undefined){
      return false
    }else {
      this.audio_RemoveCart.play();
      let index: any;
      for (let i = 0; i < products.length; i++) {
        const element = products[i];
        if (item.id == element.product.id) {
          index = i;
        }
      }
      products.splice(index, 1);
      localStorage.setItem("cartItem", JSON.stringify(products));
      
      this.presentToast("El producto fue eliminado con exito...", "bottom", "danger");
      this.getTotalAmount();
      return true;
    }
  }

  // Total amount
  public getTotalAmount() {
    let sumaParcial: any;
    let sumaTotal: any = 0;
    for (let i = 0; i < products.length; i++) {
      const element = products[i];

      sumaParcial = element.quantity * element.product.Price;
      
      sumaTotal = sumaTotal + sumaParcial;
    }
    this.Total_Cart.next(sumaTotal.toFixed(2));
  }

  /************** Carrito de compras ***************/

  /************** Listado de favoritos **************/
  // Get Products
  public getItems_favs(): Observable<any[]> {
    const itemsStream = new Observable(Observe => {
      Observe.next(favoritos);
      Observe.complete();
    });
    return <Observable<any[]>>itemsStream;
  }

  public addTofavs(product: any) {
    var item: any | boolean = false;
    let hasItem = favoritos.find((items, index) => {
      // Si el producto ya estaba en favoritos
      if(items.favoritos.id == product.id){
        this.presentToast('ya esta agregado a favoritos.', "bottom", 'danger'); 
        return true;
      }
    });

    // Si el producto es nuevo
    if(!hasItem) {
      item = { favoritos: product};
      favoritos.push(item);
      this.audio_inCart.play();
      this.presentToast('Agregado a Favoritos', "bottom", 'primary');
    };
    favoritos.reverse();
    localStorage.setItem("favItem", JSON.stringify(favoritos));
    this.Total_Favs.next(favoritos);
    return item;
  }

  // Removed in cart
  public removeFromFavs(item: any) {
    if (item === undefined){
      return false
    }else {
      this.audio_RemoveCart.play();
      let index: any;
      for (let i = 0; i < favoritos.length; i++) {
        const element = favoritos[i];
        if (item.id == element.favoritos.id) {
          index = i;
        }
      }
      favoritos.splice(index, 1);
      localStorage.setItem("favItem", JSON.stringify(favoritos));
      this.presentToast("Se removio de favoritos", "bottom", "danger");
      this.Total_Favs.next(favoritos);
      return true;
    }
  }
  
  /************** Listado de favoritos **************/

  /********* Elementos vistos Recientemente *********/
  // Get Products
  public getLastItem(): Observable<any[]> {
    const itemsStream = new Observable(Observe => {
      Observe.next(LastItem);
      Observe.complete();
    });
    return <Observable<any[]>>itemsStream;
  }

  public addToLastItem(product: any) {
    var item: any | boolean = false;
    let lastItem = { LastViewer: product };
    // Creamos la variable para ver el elemento mas reciente
    localStorage.setItem("LastItem", JSON.stringify(lastItem));

    this.LastItem_view.next(lastItem);
    return item;
  }

  /********* Elementos vistos Recientemente *********/

  setUser(Data) {
    this.User.next(Data);
  }

  Login(Phone: any) {
    return this.firestore.collection('DataUsers').doc(Phone).get();
  }

  SignupFB(Code: any, Phone: any, Key: any) { 
    return this.UpdateCodeAfil(Code, Phone).then( () => {
      this.firestore.collection('DataUsers').doc(Phone).set({
        Key: Key,
        CodeAfil: Code 
      });
    });
  }

  PhoneVerify(Phone: String) {
    const data = {
      bandera: 'VerifyPhone',
      Phone: Phone
    }
    return this.http.post(this.UrlPath,data,{
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    }).toPromise();
    // return this.http.sendRequest(this.UrlPath,{method:'post', data: {bandera: 'VerifyPhone',Phone:Phone}})
  }

  PhoneVerifyFB(Phone: any) {
    return this.firestore.collection('DataUsers').doc(Phone).get();
  }

  SignupMysql(data: any) {
    return this.http.post(this.UrlPath,data,{
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    }).toPromise();
  }

  forgotPasswrod() {
    return firebase.auth().sendPasswordResetEmail('quezada.adrian@hotmail.com');
  }

  UpdateCodeAfil(Code: any, Phone: any) {
    return this.oneSignal.getIds().then((ID) => {
     this.http.post(this.UrlPath,{bandera: 'UpdateCodeAfil',Code: Code, Phone: Phone, PlayerId:ID.userId},{
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    }).toPromise();
    });
  }

   // Codigo de Afiliacion
   CreateCode(Phone) {
    let mdd = new Md5();
    mdd.start();
    let Cod: any = mdd.appendStr(Phone).end();
    let Code: String = Cod;

    Code = Code.substr(0 , 8).toLocaleUpperCase();
    
    return Code;
   }

   GetCodeAfil(Phone: any) {
     return this.firestore.collection('DataUsers').doc(Phone).get().toPromise();
   }


   // Registro de operaciones
   DataOpReg(Data: any) {
    return this.http.post(this.UrlPath,Data,{
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    }).toPromise();
   }

   /**
    * Obtencion de Sliders principales
    */

    get_IniSlider() {
      return this.http.post(this.UrlPath,{bandera: 'SliderIni'},{
        headers: new HttpHeaders({
          'Content-type': 'application/json'
        })
      });
    }

  /**
   * Obtencion y vistas de todos los productos
   */

   get_productsTem(){
    return this.http.post(this.UrlPath,{bandera: 'ProductsTemp'},{
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    });
   }
  
  /**
   * Obtenemos el listado de categorias
   */

   get_category(){
    return this.http.post(this.UrlPath,{bandera: 'ListCategory'},{
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    });
   }

   /**
    * Enlistamos la ultima categoria que visito
    * @param Cat Categoria a recibir
    */
   Cat_lastVisit(Cat: any) {
      var item: any | boolean = false;
      // If Products exist
      let hasItem = LastCat.find((items, index) => {
        if(items.product.id == Cat.id) {
          let qty = LastCat[index].quantity + 1;
          LastCat[index]['quantity'] = qty;
          return true;
        }
      });

      // If Products does not exist (Add New Products)
      if(!hasItem) {
        item = { product: Cat, quantity: 1 };
        LastCat.push(item);
      }
      LastCat.sort((a, b) => b.quantity - a.quantity); //ordenar de forma ascendente segun las visitas
      localStorage.setItem("LastCat", JSON.stringify(LastCat));
      this.LastCatView.next(LastCat);
      return item;
   }

   get_lastCat(){
    const itemsStream = new Observable(observer => {
      observer.next(LastCat);
      observer.complete();
    });
    return <Observable<any[]>>itemsStream;
   }

   /**
    * Busqueda de productos por categoria 
    * @param Cat 
    */
   get_productsCat(Cat: any) {
    return this.http.post(this.UrlPath,{bandera: 'ProductsCatSearch',Cat:Cat},{
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    });
   }

   /**
    * Busqueda de productos
    * @param Search 
    */
   get_productsSearch(Search: any) {
    return this.http.post(this.UrlPath,{bandera: 'ProductsSearch',Search:Search},{
      headers: new HttpHeaders({
        'Content-type': 'application/json'
      })
    });
   }

   /**
    * Enlistamos la ultima busqueda que visito
    * @param Search Categoria a recibir
    */
    Cat_lastSearch(Search: any) {
        var item: any | boolean = false;
        // If Products exist
        let hasItem = LastSearch.find((items, index) => {
          if(items.product.id == Search.id) {
            let qty = LastSearch[index].quantity + 1;
            LastSearch[index]['quantity'] = qty;
            return true;
          }
        });

        // If Products does not exist (Add New Products)
        if(!hasItem) {
          item = { product: Search, quantity: 1 };
          LastSearch.push(item);
        }
        LastSearch.sort((a, b) => b.quantity - a.quantity); //ordenar de forma ascendente segun las visitas
        localStorage.setItem("LastSearch", JSON.stringify(LastSearch));
        this.LastSearchView.next(LastSearch);
        return item;
    }

    get_lastSearch(){
      const itemsStream = new Observable(observer => {
        observer.next(LastSearch);
        observer.complete();
      });
      return <Observable<any[]>>itemsStream;
    }

  /**
   * Sumamos puntos
   * @param Afil 
   */
    PointsFid(Afil: any) {
      return this.http.post(this.UrlPath,{bandera: 'SearchCodeAfil',Afil:Afil},{
        headers: new HttpHeaders({
          'Content-type': 'application/json'
        })
      });
    }
   /**
    *  Toaster
    * @param message 
    * @param position 
    * @param background 
    */
   async presentToast(message, position, background) {
    const toast = await this.toastController.create({
      color: background,
      message: message,
      position: position,
      duration: 1500,
      translucent: true,
      buttons: [
        {
          text: 'Done',
          role: 'cancel',
          handler: () => {
            // Done!!
          }
        }
      ]
    });
    toast.present();
  }

}
